import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { getConfigApi } from "../api";

const SiteConfigContext = createContext({ discount: null, loaded: false });

export const saleUnit = (price, discount) => {
  if (!discount || !discount.active) return Math.round(price * 100) / 100;
  const pct = Math.max(0, Math.min(100, Number(discount.percent) || 0));
  return Math.round(price * (1 - pct / 100) * 100) / 100;
};

export const SiteConfigProvider = ({ children }) => {
  const [discount, setDiscount] = useState(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    getConfigApi()
      .then((cfg) => setDiscount(cfg?.discount || null))
      .catch(() => setDiscount(null))
      .finally(() => setLoaded(true));
  }, []);

  const value = useMemo(() => ({ discount, loaded }), [discount, loaded]);

  return (
    <SiteConfigContext.Provider value={value}>
      {children}
    </SiteConfigContext.Provider>
  );
};

export const useSiteConfig = () => useContext(SiteConfigContext);
